import { InitialStageState } from "@utils/validation";
import { ui, state as STATE } from "../../../../../../interfaces/interfaces";

export const ACTIVE_STEPS = {
    APPOINTMENT_DATE: 0,
    CONTACT_DETAILS: 1,
    ADDRESS_DETAILS: 2,
}

export const ACTIONS = {
    SET_APPOINTMENT_DATE: (payload: boolean) => ({ id: 0, type: "SET_APPOINTMENT_DATE", payload }),
    SET_CONTACT_DETAILS: (prefix: string | string[], payload: boolean) => ({ id: 1, type: "SET_CONTACT_DETAILS", prefix, payload }),
    VERIFY_ADDRESS: (payload: boolean) => ({ id: 2, type: "VERIFY_ADDRESS", payload }),
}

export const initialStageState: InitialStageState = {
    0: {
        id: 0,
        title: "AppointmentDate",
        complete: false,
        label: 'Select appointment date',
        description: `You have to select appointment date. Provide any relevant notes related to appointment date if required. Use Emergency button only if customer is in emergency situation.`,
    },
    1: {
        id: 1,
        title: "ContactDetails",
        complete: false,
        label: 'Please enter cotnact details',
        description:
            'Collect contact details of person living in the property.',
    },
    2: {
        id: 2,
        title: "AddressDetails",
        complete: false,
        label: 'Verify Address',
        description:
            'Check and edit if any address details are incorrect.',
    },
}

export const reducer = (state: InitialStageState, action: { type: string; id: number; prefix?: string | string[]; payload?: boolean }) => {
    switch (action.type) {
        case "SET_APPOINTMENT_DATE":
            const appointment_state = state[action.id].complete
            if ((!appointment_state || !STATE.Step2_1Valid) && ui.AppointmentDate && ui.AppointmentTime) {
                state = {
                    ...state, [action.id]: { ...state[action.id], complete: true }
                }
                // set valid STATE for step 2_1
                // STATE.Step2_1Valid = true
            }
            if ((appointment_state || STATE.Step2_1Valid) && (!ui.AppointmentDate || !ui.AppointmentTime)) {
                state = {
                    ...state, [action.id]: { ...state[action.id], complete: false }
                }
                // set invalid STATE for step 2_1
                // STATE.Step2_1Valid = false
            }
            return state

        case "SET_CONTACT_DETAILS":
            const contacts_state = state[action.id].complete
            const areContactsValid = action.payload

            if (!contacts_state && areContactsValid) {
                state = {
                    ...state, [action.id]: { ...state[action.id], complete: true }
                }
            }
            if (contacts_state && !areContactsValid) {
                state = {
                    ...state, [action.id]: { ...state[action.id], complete: false }
                }
            }
            // STATE.Step2_2Valid = action.payload || false
            return state

        case "VERIFY_ADDRESS":
            const address_state = state[action.id].complete
            const areAddressDetailsValid = action.payload
            if (!address_state && areAddressDetailsValid) {
                state = {
                    ...state, [action.id]: { ...state[action.id], complete: true }
                }
            }
            if (address_state && !areAddressDetailsValid) {
                state = {
                    ...state, [action.id]: { ...state[action.id], complete: false }
                }
            }
            // STATE.Step2_3Valid = action.payload || false

            return state

        default:
            return state;
    }
};

